import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import HeaderUser from "../components/homePage/HeaderUser";
import FooterPage from "../components/homePage/FooterPage";

function Notification() {
  const token = JSON.parse(
    decodeURIComponent(Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser") || null)
  );
  const { userDetailLogin } = useSelector((state) => state.auth);

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [planDetailUser, setPlanDetailUser] = useState({});
  const [totalUserSentInterest, setTotalUserSentInterest] = useState(0);
  const [expiryDate, setExpiryDate] = useState(false);

  const formatDateTime = (dateValue) => {
    if (!dateValue) return "-";

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return "-";

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getDefaultPhoto = (member) => {
    if (member?.gender === "Female") {
      return "assets/img/no-image-female.jpg";
    }

    if (member?.gender === "Male") {
      return "assets/img/no-image-male.jpg";
    }

    return "assets/img/no-image.jpg";
  };

  const shouldBlurByPlan = () => {
    if (
      !planDetailUser ||
      Object.keys(planDetailUser).length === 0 ||
      planDetailUser?.plan_id?.name === "Basic" ||
      (planDetailUser?.plan_id?.name === "Gold" && totalUserSentInterest > parseInt(planDetailUser?.send_interest)) ||
      (planDetailUser?.plan_id?.name === "Premium" && totalUserSentInterest > parseInt(planDetailUser?.send_interest)) ||
      (expiryDate && (planDetailUser?.plan_id?.name === "Gold" || planDetailUser?.plan_id?.name === "Premium"))
    ) {
      return true;
    }

    return false;
  };

  const getMemberPhoto = (member) => {
    const clearPhoto = member?.photo;
    const blurPhoto = member?.photo_blur;
    const photoShow = member?.profileSettings?.photo_show;
    const photoRequestApproved = member?.photo_request_check && member?.photo_request_status === 1;
    const blurPhotoByPlan = shouldBlurByPlan();

    if (photoShow === 2 || photoRequestApproved) {
      return clearPhoto ? `${process.env.REACT_APP_BASE_URL_IMAGE}${clearPhoto}` : getDefaultPhoto(member);
    }

    if (photoShow === 1 || blurPhotoByPlan) {
      if (blurPhoto) {
        return `${process.env.REACT_APP_BASE_URL_IMAGE}${blurPhoto}`;
      }

      if (clearPhoto) {
        return `${process.env.REACT_APP_BASE_URL_IMAGE}${clearPhoto}`;
      }

      return getDefaultPhoto(member);
    }

    return clearPhoto ? `${process.env.REACT_APP_BASE_URL_IMAGE}${clearPhoto}` : getDefaultPhoto(member);
  };

  const fetchViewerPlanDetail = async () => {
    if (!userDetailLogin?._id) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/user-detail-all/${userDetailLogin._id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (data.status && data.data?.[0]) {
        const isExpired = new Date(data.data[0].plan_detail?.expiry_date) < new Date();
        setExpiryDate(isExpired);
        setTotalUserSentInterest(data.data[0].interest_user || 0);
        setPlanDetailUser(data.data[0].plan_detail || {});
      }
    } catch (err) {
      setPlanDetailUser({});
    }
  };

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/notifications`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data.status) {
        setNotifications(data.data || []);
      } else {
        setError(data.message || "Unable to load notifications.");
      }
    } catch (err) {
      setError("Unable to load notifications.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    fetchViewerPlanDetail();
  }, [userDetailLogin]);

  return (
    <>
      <HeaderUser />

      <section className="inrbnr">
        <div className="container-fluid con-flu-padd">
          <div className="inrbnrContent">
            <h1>Notifications</h1>
            <ul className="inrbrnNav">
              <li>
                <Link to="/dashboard">
                  <img src="assets/img/icons/home.png" alt="home icon" />
                </Link>
                <img src="assets/img/icons/arrows.png" alt="arrows icons" />
              </li>
              <li>
                <Link to="#">Notifications</Link>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="astrologersList pt-30 pb-50">
        <div className="container-fluids con-flu-padds">
          <div className="astroList">
            <div className="col-12">
              <div className="bg-des-con p-3">
                {loading && <p>Loading notifications...</p>}
                {!loading && error && <p className="error">{error}</p>}
                {!loading && !error && notifications.length === 0 && (
                  <p>No notifications found.</p>
                )}

                {!loading && !error && notifications.length > 0 && (
                  <div className="col-12">
                    {notifications.map((item) => (
                      <div className="bg-match-profile mb-2" key={item.id}>
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          <div className="d-flex align-items-center">
                            {item.member ? (
                              <div className="img-mess-2">
                                <img
                                  src={getMemberPhoto(item.member)}
                                  alt={item.member?.name || "member"}
                                  style={{ width: 70, height: 90, objectFit: "cover", borderRadius: 4 }}
                                />
                              </div>
                            ) : (
                              <div className="img-mess-2">
                                <img src="assets/img/icons/bell-1.png" alt="notification" />
                              </div>
                            )}

                            <div className="con-metch">
                              <h5>{item.title}</h5>
                              <p>{item.message}</p>
                              <small>{formatDateTime(item.createdAt)}</small>
                            </div>
                          </div>

                          {item.member?.profile_id && (
                            <Link to={`/profile-details/${item.member._id}`} className="button">
                              View Profile
                            </Link>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterPage />
    </>
  );
}

export default Notification;